import React, { memo } from 'react';
import { Space, Alert, List, Text } from '@cashfree-intl/coherent';

// Components
import BackButton from 'components/BackButton';

// Styled
import { StyledWhitelistStepTwo } from '../styled';

// Constants
import { OTHER_DETAILS, TEST_IDS, WEBSITE_POLICIES } from '../constants';

// Types
import { WhitelistStepTwoProps } from '../types';

const WhitelistStepTwo = ({
  onBackClick,
  isWebsite,
}: WhitelistStepTwoProps) => {
  return (
    <StyledWhitelistStepTwo
      direction="column"
      data-testid={TEST_IDS.WHITELIST_STEP_TWO}
    >
      <BackButton onClick={onBackClick} data-testid={TEST_IDS.BACK_BUTTON} />
      <Space direction="column" className="body mt-4">
        <Alert className="alert mb-2" type="warning" compact bordered>
          Please ensure the following details are present in your
          {isWebsite ? ' website' : ' app'} for whitelisting
        </Alert>
        <Text variant="b14" className="title mt-2">
          Policy pages
        </Text>
        <List as="ol">
          {WEBSITE_POLICIES.map((policy, index) => (
            <List.Item value={`${index + 1}.`} as="li" key={policy}>
              <List.Content>{policy}</List.Content>
            </List.Item>
          ))}
        </List>
        <Text variant="b14" className="title mt-2">
          Other Details
        </Text>
        <List as="ol">
          {OTHER_DETAILS.map((detail, index) => (
            <List.Item value={`${index + 1}.`} as="li" key={detail}>
              <List.Content>{detail}</List.Content>
            </List.Item>
          ))}
        </List>
      </Space>
    </StyledWhitelistStepTwo>
  );
};

export default memo(WhitelistStepTwo);
